import React from 'react';

import Location from './Location';
import CheckinCd from './CheckinCd';
import Timer from './Timer';
import Photo from './Photo';
import Text from './Text';
import StartUploading from "./StartUploading";
import FinishLoading from "./FinishLoading";
import CheckinClient from "./CheckinClient";
import CheckoutClient from "./CheckoutClient";

const DeliveryItem = ({ data }) => {

    switch(data.type) {
        case 'checkin_cd':
            return (<CheckinCd data={data} />);

        case 'start_uploading':
            return (<StartUploading data={data} />);

        case 'finish_loading':
            return (<FinishLoading data={data} />);

        case 'checkin_client':
            return (<CheckinClient data={data} />);

        case 'checkout_client':
            return (<CheckoutClient data={data} />);

        case 'location':
            return (<Location data={data} />);

        case 'timer':
            return (<Timer data={data} />);

        case 'photo':
            return (<Photo data={data} />);

        default:
            return (<Text data={data} />);
    }

}

export default DeliveryItem;



// WEBPACK FOOTER //
// ./src/components/Timeline/Activities/index.js